import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router'

import Authorize from 'app/components/Authorize'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import RenderAssignmentLists from './RenderAssignmentLists'
import MainLeftNav from '../components/MainLeftNav'
import AppraiserProfile from '../components/AppraiserProfile'
import GeographicAreas from '../components/GeographicAreas'
import UnavailabilityDates from '../components/UnavailabilityDates'
import AppraisalSearchBar from '../components/AppraisalSearchBar'
import AppraiserHeader from '../components/AppraiserHeader'
import AssignmentContainer from '../../assignment/components/common/AssignmentContainer'
import AssignmentLeftNav from '../../assignment/components/common/AssignmentLeftNav'

import { fetchAppraiser } from '../actions/fetchAppraiserAction'
import fetchAllAssignmentLists from '../actions/fetchAssignmentListsActions'

import '../style/appraisal.scss'

const AppraisalContainer = (props) => {
  let { fetchAppraiser, fetchAllAssignmentLists, user, appraiserInfo } = props

  useEffect(() => {
    if (user.entities.some(e => e.name === 'AppraiserInspector')) {
      fetchAppraiser(user.entities.find(e => e.name === 'AppraiserInspector').values.id)
      fetchAllAssignmentLists()
    }
  }, [fetchAppraiser, fetchAllAssignmentLists, user])

  return (
    <div className='appraisal-workspace usa-grid'>
      <Authorize
        gearAuth={['APPLICATION_Appraiser Portlet']}
        gearName='the Appraiser Workspace'
        callback={inactiveAppraiser(appraiserInfo, user)}>
        <div className='usa-width-one-fourth appraisal-workspace-leftnav'>
          <Switch>
            <Route exact path='/lgyhub/appraiser/(profile|unavailability|geographic-areas|locate-cases)?/(canceled-90-days|all-90-days|with-uploads)?' component={MainLeftNav} />
            <Route path='/lgyhub/appraiser/(locate-cases|search)?/(canceled-90-days|all-90-days|with-uploads)?/:assignmentId' component={AssignmentLeftNav} />
          </Switch>
          <AppraisalSearchBar {...props} />
        </div>
        <div className='usa-width-three-fourths appraisal-workspace-main'>
          <Switch>
            <Route exact path='/lgyhub/appraiser/(profile|unavailability|geographic-areas|locate-cases)?/(canceled-90-days|all-90-days|with-uploads)?' render={() => <AppraiserHeader {...props} />} />
            <Route path='/lgyhub/appraiser/(locate-cases|search)?/(canceled-90-days|all-90-days|with-uploads)?/:assignmentId' component={AssignmentContainer} />
          </Switch>
          <Route exact path='/lgyhub/appraiser' render={() => <RenderAssignmentLists {...props} workspace />} />
          <Route exact path='/lgyhub/appraiser/profile' render={() => <AppraiserProfile {...props} />} />
          <Route exact path='/lgyhub/appraiser/unavailability' render={() => <UnavailabilityDates {...props} />} />
          <Route exact path='/lgyhub/appraiser/geographic-areas' render={() => <GeographicAreas {...props} />} />
          <Route exact path='/lgyhub/appraiser/locate-cases/(canceled-90-days|all-90-days|with-uploads)?' render={() => <RenderAssignmentLists {...props} />} />
        </div>
      </Authorize>
    </div>
  )
}

export const inactiveAppraiser = (appraiser, user) => {
  if (!appraiser.fetching && user.affiliations.some(aff => aff.name === 'APPRAISER')) {
    if (appraiser.appraiserStatusCode && appraiser.appraiserStatusCode !== 'A' && appraiser.appraiserStatusCode !== 'P') {
      return <LgyAlertDialog className='lgy-alert-inactive-appraiser' type='warning' heading='Inactive Account'>
        Your Appraiser ID is no longer active in the SIM system. Please contact the VA RLC to have them activate your account. 
        Once the RLC corrects your information, please log-in to LGY Hub again. If you are not sure how to contact your VA RLC 
        please see{' '}
        <a href='https://www.benefits.va.gov/HOMELOANS/contact_rlc_info.asp' target='_blank' rel='noopener noreferrer'>
        Regional Loan Center Contact Information
        </a>
      </LgyAlertDialog>
    } else if (appraiser.error) {
      return <LgyAlertDialog className='lgy-alert-inactive-appraiser' type='warning' heading='Registration Data Mismatch'>
        There is a difference between the LGY HUB registration data and your existing appraiser record in SIM. Please
        contact the VA RLC to have them correct mismatched data such as SSN, phone, etc. for you. Once the RLC corrects
        your information, please log-in to LGY Hub again. If you are not sure how to contact your VA RLC please see{' '}
        <a href='https://www.benefits.va.gov/HOMELOANS/contact_rlc_info.asp' target='_blank' rel='noopener noreferrer'>
          Regional Loan Center Contact Information
        </a>.
      </LgyAlertDialog>
    }
  }
  return null
}

const mapStateToProps = (state) => ({
  appraiserInfo: state.appraiser.workspace.appraiserProfile,
  user: state.currentUser
})

const mapDispatchToProps = ({ fetchAppraiser, fetchAllAssignmentLists })

export default connect(mapStateToProps, mapDispatchToProps)(AppraisalContainer)
